import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { fetchWithAuth } from './authService';
import { API_ENDPOINTS } from '../utils/constants';

function LiveUsersPage() {
  const { vid } = useParams();
  const navigate = useNavigate();
  const [liveUsers, setLiveUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);

  const token = localStorage.getItem('tringAuthToken');

  const handleClose = () => {
    navigate(-1);
  };

  useEffect(() => {
    async function fetchUsers() {
      setLoading(true);
      try {
        const res = await fetchWithAuth(API_ENDPOINTS.VENUE_USERS(vid), {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error('Failed to fetch users');
        const liveUserData = await res.json();
        setLiveUsers(liveUserData);
      } catch (err) {
        console.error('Error fetching live users:', err);
        setLiveUsers([]);
      }
      setLoading(false);
    }
    if (vid && token) fetchUsers();
  }, [vid, token]);

  const gradientTextStyle = {
    background: 'linear-gradient(90deg, #CC151E, #873662)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
  };

  const UserModal = ({ user, onClose }) => {
    if (!user) return null;
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'black',
          color: 'white',
          display: 'flex',
          flexDirection: 'column',
          zIndex: 10000,
        }}
      >
        {/* Header with back arrow + name */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '16px',
          }}
        >
          <IoIosArrowBack
            style={{
              fontSize: '31px',
              cursor: 'pointer',
              color: '#fff',
            }}
            onClick={onClose}
          />
          <span style={{ fontSize: '21px', fontWeight: '500' }}>
            {user.first_name} {user.last_name}
          </span>
        </div>

        {/* Centered profile picture */}
        <div
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src={user.avatar || '/default-avatar.png'}
            alt={`${user.first_name || ''} ${user.last_name || ''}`}
            style={{
              borderRadius: '50%',
              width: 200,
              height: 200,
              objectFit: 'cover',
              border: '3px solid white',
              marginBottom: '140px',
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <div
      style={{
        width: '100%',
        height: '100vh',
        backgroundColor: '#f5f5f5',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Title Bar */}
      <div
        style={{
          backgroundColor: 'white',
          padding: '16px',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          borderBottom: '1px solid #e5e5e5',
        }}
      >
        <IoIosArrowBack
          style={{
            fontSize: '24px',
            color: '#CC151E',
            cursor: 'pointer',
          }}
          onClick={handleClose}
        />

        <h2
          style={{
            margin: 0,
            fontSize: '19px',
            fontWeight: '500',
            ...gradientTextStyle,
          }}
        >
          Audience ({liveUsers.length})
        </h2>
      </div>

      {/* Users List */}
      <div
        style={{
          flex: 1,
          backgroundColor: 'white',
          overflowY: 'auto',
          padding: '0',
        }}
      >
        {loading ? (
          <div
            style={{
              padding: '20px',
              textAlign: 'center',
              ...gradientTextStyle,
            }}
          >
            Loading...
          </div>
        ) : (
          liveUsers.map((user, index) => (
            <div key={index}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '10px 16px',
                  borderBottom: '0.5px solid rgba(0,0,0,0.1)',
                  cursor: 'pointer',
                  userSelect: 'none',
                }}
                onClick={() => setSelectedUser(user)}
              >
                {/* Avatar + Name */}
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '16px' }}
                >
                  <img
                    style={{
                      borderRadius: '50%',
                      width: '40px',
                      height: '40px',
                      objectFit: 'cover',
                    }}
                    src={user?.avatar || '/default-avatar.png'}
                    alt={`${user?.first_name || ''} ${user?.last_name || ''}`}
                  />
                  <span
                    style={{
                      fontSize: '16px',
                      fontWeight: '400',
                      ...gradientTextStyle,
                      userSelect: 'none',
                    }}
                  >
                    {user?.first_name} {user?.last_name}
                  </span>
                </div>
                <IoIosArrowForward
                  style={{ fontSize: '20px', color: '#e6454a' }}
                />
              </div>
            </div>
          ))
        )}
        <UserModal user={selectedUser} onClose={() => setSelectedUser(null)} />
      </div>
    </div>
  );
}

export default LiveUsersPage;
